import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    'table',
    'row',
    'existingRow',
    'actionCell'
  ]

  connect() {
    // 初期表示時も差分をハイライト
    this.rowTargets.forEach((row) => this.#applyDiffHighlight(row))
  }

  onChangeAction(event) {
    const radio = event.currentTarget
    const idx = radio.dataset.index
    const mode = radio.value // 'create' or 'overwrite'

    const row = this.rowTargets.find(r => r.dataset.rowIndex === String(idx))
    const existing = this.existingRowTargets.find(r => r.dataset.rowIndex === String(idx))

    if (!row) return

    if (mode === 'overwrite') {
      // Hide the existing row and highlight differences in the CSV row
      if (existing) existing.classList.add('is-hidden')
    } else {
      // Show both rows and remove highlight
      if (existing) existing.classList.remove('is-hidden')
    }

    // ラジオ切替後も差分ハイライトを維持/再計算
    this.#applyDiffHighlight(row)
  }

  #applyDiffHighlight(rowEl) {
    // Compare each cell's displayed text against data-existing-value
    const cells = Array.from(rowEl.querySelectorAll('[data-existing-value]'))
    cells.forEach((cell) => {
      const existing = (cell.dataset.existingValue || '').trim()
      // Build displayed value for comparison: take the textContent before any validation error text if present
      // We take the first text node's content by cloning and removing inner .error nodes.
      let displayed = cell.cloneNode(true)
      displayed.querySelectorAll('.error').forEach((n) => n.remove())
      const value = (displayed.textContent || '').trim()
      const isDifferent = existing !== '' && value !== '' && existing !== value
      if (isDifferent) {
        cell.classList.add('has-background-warning')
      } else {
        cell.classList.remove('has-background-warning')
      }
    })
  }
}
